import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { isSome } from 'core/utils';

const SearchFilterTemplate = ({
	t,
	searchFilterStore: {
		searchTerm,
		onKeyPress,
		onValueChange,
		searchForTerm,
		clearSearchField,
		placeholder,
		queryUtility: { filter },
	},
}) => {
	return (
		<section>
			<div className="pos--rel header__search__wrap">
				<div className="header__search__input">
					<input
						className="input"
						type="text"
						placeholder={t(placeholder || 'SEARCH')}
						value={searchTerm || ''}
						onChange={onValueChange}
						onKeyPress={onKeyPress}
					/>
					{((isSome(searchTerm) && searchTerm.length > 0) || isSome(filter.search)) && (
						<span className="input__clear" onClick={clearSearchField}></span>
					)}
				</div>

				<div className="header__search__btn">
					<button className="btn btn--med btn--tertiary" onClick={searchForTerm}>
						<i className="fa fa-search header__search__icon"></i>
					</button>
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(SearchFilterTemplate);
